/**
 * This is code sepcifically for an experimenet and shouldn't
 * be considered blessed/structural until over. Will probably want to
 * refactor AppModalWave in to something more intentional if we keep
 * the experience/UI over the control.
 *
 * https://github.com/babylist/web/pull/8496
 */
import React from 'react'
import PropTypes from 'prop-types'

import { Modal, ModalBody } from 'components/modal'

import {
  AppPromoWave,
  AppPromoStartBuilding,
  AppPromoNextStep,
  AppPromoCollaborator,
} from '../app-promo/app-promo-wave'
import css from '../app-promo/app-promo.scss'

export const AppModalWave = ({ isVisible, hideModal, children }) => {
  return (
    <Modal
      className={css.promoWaveModal}
      size="fullscreen"
      show={isVisible}
      onHide={hideModal}
    >
      <ModalBody>{children}</ModalBody>
    </Modal>
  )
}

AppModalWave.propTypes = {
  hideModal: PropTypes.func,
  isVisible: PropTypes.bool,
  children: PropTypes.node,
}

AppModalWave.defaultProps = {
  isVisible: false,
}

export const AppPromoAddItemModal = ({ hideModal, ...props }) => (
  <AppModalWave {...props}>
    <AppPromoWave onClose={hideModal} />
  </AppModalWave>
)

export const AppPromoStartBuildingModal = (props) => (
  <AppModalWave {...props}>
    <AppPromoStartBuilding />
  </AppModalWave>
)

export const AppPromoNextStepModal = ({ hideModal, ...props }) => (
  <AppModalWave {...props}>
    <AppPromoNextStep onClose={hideModal} />
  </AppModalWave>
)

export const AppPromoCollaboratorModal = ({ registrantNames, ...props }) => (
  <AppModalWave {...props}>
    <AppPromoCollaborator registrantNames={registrantNames} />
  </AppModalWave>
)
